import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
export class VaporesSemanalesProveedorDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { viaje: "" };
        }
    }
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <FormGroup>
                            <FormattedMessage id='¿Esta seguro de eliminar este elemento?' />
                            
                        </FormGroup>
                    </Form>
                </Row>
            </div>
        );
    }

}